<template>
<div id="main-content" class="taskboard">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-lg-6 col-md-8 col-sm-12">
          <h2><a href="javascript:void(0);" class="btn btn-xs btn-link btn-toggle-fullwidth"><i class="fa fa-arrow-left"></i></a> Tickets</h2>
          <ul class="breadcrumb">
            <li class="breadcrumb-item"><a href="index.html"><i class="icon-home"></i></a></li>                            
            <li class="breadcrumb-item">Apps</li>
            <li class="breadcrumb-item active">Tickets</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12 col-md-12">
        <div class="card">
          <div class="header">
            <h2>Report QBO</h2>
          </div>
          <div class="body">
            <div class="row">
              <div class="form-group col-3">
                <label for="subject">Start Date</label>
                <flat-pickr class="form-control" v-model="reportCPARPartial.startDate" ></flat-pickr>
              </div>
              <div class="form-group col-3">
                <label for="subject">To Date</label>
                <flat-pickr class="form-control" v-model="reportCPARPartial.toDate"></flat-pickr>
              </div>
            </div>
            <button type="button" class="btn btn-outline-success" @click="print">Print <i class="far fa-save"></i></button>
            <button type="button" class="btn btn-outline-danger" @click="cancel">Close Page <i class="far fa-window-close"></i></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue'
import api from '../../services/api'
import { reportCPARPartial } from '../../models/reportCPARPartial'
import { prettifyErrorMessage } from '../../utils'
import download from 'js-file-download';

export default {
  components: {
    
  },
  data() {
    return {
      reportCPARPartial: {
        ...reportCPARPartial
      },
    }
  },
  async created() {

  },
  methods: {
    async print() {
      // const empApi = api('employee')
      // if(this.$route.query.id !== undefined) {
      //   await empApi.update(this.employee, this.$route.query.id)
      // } else {
      //   await empApi.create(this.employee)
      // }


      const rptApi = api('report-cpar-partial')
      const query = { 
        params: {
          startDate: this.reportCPARPartial.startDate,
          toDate: this.reportCPARPartial.toDate,
        }
      }
      const excelFile = await rptApi.getFileWithQuery(query)
      download(excelFile, 'CPAR-REPORT.xlsx')
    },
    cancel() {
      this.$router.go(-1)
    },
  }
}
</script>